import React from "react";

const Checkbox = ({ className, value, onChange, name, ...props }) => {
  return (
    <input
      className={`${className}
      bg-tripplo-600
      rounded-lg
      py-3
      px-16
      border
      text-black
      border-tripplo-300
      focus:outline-none
      focus:bg-white"`}
      value={value}
      onChange={onChange}
      {...props}
      name={name}
      type="checkbox"
    />
  );
};

export default Checkbox;
